import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import * as RegexPattern from '@teem/constants/regex-patterns';
import { Proposal } from '@teem/models/proposal';

@Component({
  selector: 'edit-proposal-project-detail',
  templateUrl: './project-detail.component.html',
  styles: []
})
export class ProjectDetailComponent implements OnInit {
  @Input() proposal: Proposal;
  @Output() triggerPrevious: EventEmitter<any> = new EventEmitter();
  @Output() onComplete: EventEmitter<any> = new EventEmitter();
  submitted: boolean = false;
  projectDetailForm: FormGroup;
  inspirationLinkForm: FormGroup;
  links: Array<string> = [];
  linkSubmitted: boolean = false;
  newFiles: Array<File> = [];
  files: Array<any> = [];
  deletedFiles: Array<any> = [];

  constructor(
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.projectDetailForm = this.fb.group({
      title: [this.proposal.title, Validators.required],
      description: [this.proposal.description, Validators.required],
      comments: [this.proposal.comments]
    })

    if (this.proposal.links) {
      this.links = this.proposal.links;
    }

    if (this.proposal.attachments) {
      this.files = this.proposal.attachments;
    }

    this.inspirationLinkForm = this.fb.group({
      link: ['', [Validators.required, Validators.pattern(RegexPattern.url_without_http)]]
    })
  }

  handleFileInput(files: FileList) {
    this.newFiles = this.newFiles.concat(Object.values(files));
  }

  removeNewFile(index: number) {
    this.newFiles.splice(index, 1);
  }

  removeOldFile(index: number) {
    let deleted = this.files.splice(index, 1);
    this.deletedFiles.push(deleted[0].uuid)
  }

  submit() {
    this.submitted = true;

    if (this.projectDetailForm.valid) {
      let fd = this.projectDetailForm.value;

      if (this.links && this.links.length)
        fd.links = this.links;

      if (this.files)
        fd.files = this.files;

      if (this.newFiles)
        fd.new_files = this.newFiles;

      if (this.deletedFiles && this.deletedFiles.length)
        fd.deleted_files = this.deletedFiles;


      this.onComplete.emit(fd);
    }
  }

  addLink() {
    this.linkSubmitted = true;
    if (this.inspirationLinkForm.valid) {
      let link = this.inspirationLinkForm.get('link').value;

      if (!RegexPattern.http_check.test(link)) {
        link = "http://" + link;
      }

      this.links.push(link);
      this.linkSubmitted = false;
      this.inspirationLinkForm.reset();
    }
  }

  removeLink(i: number) {
    this.links.splice(i, 1);
  }

}
